<template>
  <emd-alert
    variant="warning"
    class="eu-mb_4"
    no-close
  >
    <template slot="content">
      <p>
        {{ computedDescription }}
      </p>
    </template>
  </emd-alert>
</template>

<script>
import { EmdAlert } from 'emerald-vue/src/components'

export default {
  name: 'AlertTestAccount',

  components: {
    EmdAlert
  },

  props: {
    limit: {
      type: Number,
      required: true
    }
  },

  computed: {
    computedDescription () {
      return this.$t('description', [this.limit])
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "description": "Limite máximo de chaves atendidas: {0}. Para criar novas chaves é necessário deletar chaves antigas."
    },
    "en-US": {
      "description": "Limite máximo de chaves atendidas: {0}. Para criar novas chaves é necessário deletar chaves antigas."
    }
  }
</i18n>
